// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N2E4","index":"styles_index__3qVuM"};